export default "__VITE_ASSET__BlTadi5P__"